import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const PaperAirplane = (props: SvgProps) => (
  <Svg width={26} height={26} viewBox="0 0 26 26" fill="none" {...props}>
    <path
      d="M7.49594 17.2821L21.4385 1.84122L17.217 12.3929L8.87514 23.681L7.49594 17.2821Z"
      fill="url(#paint0_linear_11308_41083)"
    />
    <path
      d="M2.08892 15.2226L21.4385 1.84121L7.51645 17.2741L2.08892 15.2226Z"
      fill="url(#paint1_linear_11308_41083)"
    />
    <g filter="url(#filter0_i_11308_41083)">
      <path
        d="M2.08892 15.2226L21.4385 1.84121L7.51645 17.2741L2.08892 15.2226Z"
        fill="url(#paint2_linear_11308_41083)"
        style={{ mixBlendMode: "hard-light" }}
      />
    </g>
    <path
      d="M8.87324 23.6973L15.1267 19.6727L12.0417 18.9928L8.87324 23.6973Z"
      fill="url(#paint3_linear_11308_41083)"
    />
    <path
      d="M8.87312 23.6973L15.2623 19.6379L12.1774 18.9579L8.87312 23.6973Z"
      fill="url(#paint4_linear_11308_41083)"
    />
    <path
      d="M7.51632 17.2742L7.54333 17.3868L7.54131 17.3859L8.93607 23.4229L12.0364 18.9893L12.1727 19.0173L12.1708 19.0184L19.5639 20.6512L19.5457 20.7485L12.1009 19.1186L8.87329 23.6968L7.43556 17.3468L2.10079 15.3841L2.08887 15.2244L7.51632 17.2742Z"
      fill="url(#paint5_linear_11308_41083)"
    />
    <path
      d="M19.5627 20.669L21.4384 1.84123L12.0417 18.9928L19.5627 20.669Z"
      fill="url(#paint6_linear_11308_41083)"
    />
    <g filter="url(#filter1_i_11308_41083)">
      <path
        d="M19.559 20.6712L21.4385 1.84121L12.0412 18.9927L19.559 20.6712Z"
        fill="url(#paint7_linear_11308_41083)"
        fillOpacity="0.5"
      />
    </g>
    <g filter="url(#filter2_f_11308_41083)">
      <path
        d="M7.55518 17.1781L21.3083 1.97127"
        stroke="#F7F7F7"
        strokeWidth="0.120246"
        strokeLinecap="round"
      />
    </g>
    <g filter="url(#filter3_f_11308_41083)">
      <path
        d="M12.3591 18.9616L21.3682 2.04675"
        stroke="white"
        strokeWidth="0.120246"
        strokeLinecap="round"
      />
    </g>
    <g filter="url(#filter4_f_11308_41083)">
      <path
        d="M12.3938 18.9591L16.7144 10.5066L21.3681 2.04681"
        stroke="#DFDFDF"
        strokeOpacity="0.5"
        strokeWidth="0.0480983"
        strokeLinecap="round"
        style={{ mixBlendMode: "plus-lighter" }}
      />
    </g>
    <path
      d="M7.51367 17.2963L20.7506 2.73601"
      stroke="white"
      strokeWidth="0.0480983"
      strokeLinecap="round"
      style={{ mixBlendMode: "plus-lighter" }}
    />
    <g filter="url(#filter5_f_11308_41083)">
      <path
        d="M12.0619 18.9245L21.4385 1.84124L7.61882 17.3497L8.90878 23.4609L12.0619 18.9245Z"
        fill="url(#paint8_linear_11308_41083)"
        fillOpacity="0.5"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_11308_41083"
        x="1.86521"
        y="1.84122"
        width="19.5733"
        height="15.6565"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.505032" dy="0.240491" />
        <feGaussianBlur stdDeviation="0.111829" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_11308_41083"
        />
      </filter>
      <filter
        id="filter1_i_11308_41083"
        x="12.041"
        y="1.84122"
        width="9.39746"
        height="19.0464"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.216442" />
        <feGaussianBlur stdDeviation="0.138283" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_11308_41083"
        />
      </filter>
      <filter
        id="filter2_f_11308_41083"
        x="7.35082"
        y="1.76684"
        width="14.1621"
        height="15.6157"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.0721474"
          result="effect1_foregroundBlur_11308_41083"
        />
      </filter>
      <filter
        id="filter3_f_11308_41083"
        x="11.9381"
        y="1.62587"
        width="9.85087"
        height="17.7566"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.180369"
          result="effect1_foregroundBlur_11308_41083"
        />
      </filter>
      <filter
        id="filter4_f_11308_41083"
        x="11.9343"
        y="1.58748"
        width="9.89304"
        height="17.8309"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.217645"
          result="effect1_foregroundBlur_11308_41083"
        />
      </filter>
      <filter
        id="filter5_f_11308_41083"
        x="7.25792"
        y="1.48051"
        width="14.5413"
        height="22.3411"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0"
          result="effect1_foregroundBlur_11308_41083"
        />
      </filter>
      <linearGradient
        id="paint0_linear_11308_41083"
        x1="7.67277"
        y1="7.49225"
        x2="18.1737"
        y2="13.3586"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCFEFD" />
        <stop offset="1" stopColor="#2A2A2A" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_11308_41083"
        x1="17.9683"
        y1="2.87626"
        x2="12.5412"
        y2="16.8989"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9D9D9" />
        <stop offset="0.774038" stopColor="#303030" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_11308_41083"
        x1="21.4758"
        y1="2.07385"
        x2="4.47709"
        y2="16.6353"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9D9D9" />
        <stop offset="1" stopColor="#9B9B9B" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_11308_41083"
        x1="11.7372"
        y1="18.9776"
        x2="12.0667"
        y2="23.3905"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#0C0C0C" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_11308_41083"
        x1="10.9299"
        y1="22.137"
        x2="14.984"
        y2="19.812"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0" />
        <stop offset="1" stopColor="#FCFEFD" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_11308_41083"
        x1="2.4492"
        y1="15.3469"
        x2="19.0189"
        y2="20.8861"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#969696" />
        <stop offset="1" stopColor="#353535" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_11308_41083"
        x1="16.2074"
        y1="2.14553"
        x2="17.6014"
        y2="20.8154"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_11308_41083"
        x1="16.2825"
        y1="2.14552"
        x2="17.6765"
        y2="20.8154"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9D9D9" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_11308_41083"
        x1="14.2315"
        y1="2.00214"
        x2="14.771"
        y2="15.884"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C4C4C4" stopOpacity="0" />
        <stop offset="1" stopColor="#323232" />
      </linearGradient>
    </defs>
  </Svg>
);

export default PaperAirplane;
